import { GET_EVENT_GUIDE_DETAILS} from "../../utils/constants";


const initialState = [];

function eventGuideReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_EVENT_GUIDE_DETAILS:
            return [...state, payload];

        default:
            return state;
    }
};

export default eventGuideReducer